export default (processMapping, processHandler) => Object.keys(processMapping)
  .reduce((acc, key) => Object.assign(acc, {
    [key]: nextProcessProps => {
      processHandler(processMapping[key], nextProcessProps)
    },
  }), {})
